export var name = 'sendLog';
export var supports = function (env) {
    return env.isInAweme || env.isInHotsoon || env.isInFlash || env.isInSuper;
};
